import { ValkTalkPostFormData } from '../../../../entities/ValkTalkPost/ValkTalkPost'
import {
    hasValkTalkPostContent,
    VALK_TALK_POST_IMAGE_MAX_FILE_SIZE,
} from '../../../../entities/ValkTalkPost/ValkTalkPostHelpers'
import trans from '../../../../helpers/trans'
import { FormError, FormValidation, validateForm } from '../../../../services/validationService'

export interface ValkTalkPostFormErrors {
    content?: FormError
}

export const VALK_TALK_POST_IMAGE_MIME_TYPES = ['image/jpeg', 'image/png', 'image/gif', 'image/webp']

export const validateValkTalkPostFormData = (
    formData: ValkTalkPostFormData,
): FormValidation<ValkTalkPostFormErrors> => {
    const errors: ValkTalkPostFormErrors = {
        content: hasValkTalkPostContent(formData)
            ? undefined
            : trans('containers.forms.valkTalkPostForm.errors.contentRequired'),
    }

    return validateForm<ValkTalkPostFormErrors>(errors)
}

export const validateValkTalkPostImageFile = (file: File): FormError => {
    if (! VALK_TALK_POST_IMAGE_MIME_TYPES.includes(file.type)) {
        return trans('containers.forms.valkTalkPostForm.errors.invalidImageType', { fileName: file.name })
    }

    if (file.size > VALK_TALK_POST_IMAGE_MAX_FILE_SIZE) {
        return trans('containers.forms.valkTalkPostForm.errors.imageTooLarge', {
            fileName: file.name,
            maxSize: String(VALK_TALK_POST_IMAGE_MAX_FILE_SIZE / 1024 / 1024),
        })
    }

    return undefined
}
